export interface Billers {
    id: number;
}

export interface BillersState {
    billers: Billers[];
}

export const initialBillersInitialState: BillersState = {
    billers: []
};
